import { createRouter, createWebHistory } from "vue-router";
// createWebHistory;  历史模式
// createWebHashHistory;  哈希模式
let routes = [
    {
        path: "/transverse",
        redirect: "/transverse/t_kefu",
        component: () => import("@/views/transverse/index.vue"),
        children: [{
            path: "t_ptb",
            name: "t_ptb",
            component: () => import("@/views/transverse/ptb/index.vue"),
            meta: {
                active: 0
            }
        }, {
            path: "t_coupon",
            name: "t_coupon",
            component: () => import("@/views/transverse/coupon/index.vue"),
            meta: {
                active: 0
            }
        },
        {
            path: "t_accountCenter",
            name: "t_accountCenter",
            component: () => import("@/views/transverse/accountCenter/index.vue"),
            meta: {
                active: 1
            }
        }, {
            path: "t_notice",
            name: "t_notice",
            component: () => import("@/views/transverse/accountCenter/components/notice.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "t_accountManage",
            name: "t_accountManage",
            component: () => import("@/views/transverse/accountManage/index.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "t_addAccount",
            name: "t_addAccount",
            component: () => import("@/views/transverse/accountManage/componemts/addAccount.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "t_invoice",
            name: "t_invoice",
            component: () => import("@/views/transverse/invoice/index.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "t_gift",
            name: "t_gift",
            component: () => import("@/views/transverse/gift/index.vue"),
            meta: {
                active: 2
            }
        }, {
            path: "t_kefu",
            name: "t_kefu",
            component: () => import("@/views/transverse/kefu/index.vue"),
            meta: {
                active: 3
            }
        }, {
            path: "t_setting",
            name: "t_setting",
            component: () => import("@/views/transverse/setting/index.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "t_updateNickname",
            name: "t_updateNickname",
            component: () => import("@/views/transverse/setting/components/updateNickname.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "t_editPassword",
            name: "t_editPassword",
            component: () => import("@/views/transverse/setting/components/editPassword.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "t_bindTel",
            name: "t_bindTel",
            component: () => import("@/views/transverse/setting/components/bindTel.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "t_yinsi",
            name: "t_yinsi",
            component: () => import("@/views/transverse/setting/components/yinsi.vue"),
            meta: {
                active: 4
            }
        },
        {
            path: "t_xieyi",
            name: "t_xieyi",
            component: () => import("@/views/transverse/setting/components/xieyi.vue"),
            meta: {
                active: 4
            }
        }
        ]
    }, {
        path: "/vertical",
        name: "vertical",
        component: () => import("@/views/vertical/index.vue"),
        redirect: "/vertical/v_kefu",
        children: [{
            path: "v_ptb",
            name: "v_ptb",
            component: () => import("@/views/vertical/ptb/index.vue"),
            meta: {
                active: 0
            }
        }, {
            path: "v_coupon",
            name: "v_coupon",
            component: () => import("@/views/vertical/coupon/index.vue"),
            meta: {
                active: 0
            }
        },
        {
            path: "v_accountCenter",
            name: "v_accountCenter",
            component: () => import("@/views/vertical/accountCenter/index.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "v_notice",
            name: "v_notice",
            component: () => import("@/views/vertical/accountCenter/components/notice.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "v_accountManage",
            name: "v_accountManage",
            component: () => import("@/views/vertical/accountManage/index.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "v_addAccount",
            name: "v_addAccount",
            component: () => import("@/views/vertical/accountManage/componemts/addAccount.vue"),
            meta: {
                active: 1
            }
        },
        {
            path: "v_invoice",
            name: "v_invoice",
            component: () => import("@/views/vertical/invoice/index.vue"),
            meta: {
                active: 1
            }
        },
        //  {
        //     path: "v_notice",
        //     name: "v_notice",
        //     component: () => import("@/views/vertical/notice/index.vue"),
        //     meta: {
        //         active: 1
        //     }
        // },
        {
            path: "v_gift",
            name: "v_gift",
            component: () => import("@/views/vertical/gift/index.vue"),
            meta: {
                active: 2
            }
        }, {
            path: "v_kefu",
            name: "v_kefu",
            component: () => import("@/views/vertical/kefu/index.vue"),
            meta: {
                active: 3
            }
        }, {
            path: "v_setting",
            name: "v_setting",
            component: () => import("@/views/vertical/setting/index.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "v_updateNickname",
            name: "v_updateNickname",
            component: () => import("@/views/vertical/setting/components/updateNickname.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "v_editPassword",
            name: "v_editPassword",
            component: () => import("@/views/vertical/setting/components/editPassword.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "v_bindTel",
            name: "v_bindTel",
            component: () => import("@/views/vertical/setting/components/bindTel.vue"),
            meta: {
                active: 4
            }
        }, {
            path: "v_yinsi",
            name: "v_yinsi",
            component: () => import("@/views/vertical/setting/components/yinsi.vue"),
            meta: {
                active: 4
            },

        }, {
            path: "v_xieyi",
            name: "v_xieyi",
            component: () => import("@/views/vertical/setting/components/xieyi.vue"),
            meta: {
                active: 4
            }
        }]
    },
    {
        path: "/notice",
        name: "notice",
        component: () => import("@/views/notice/index.vue"),
    },
    {
        path: "/h5pay",
        name: "h5pay",
        component: () => import("@/views/pay/h5pay.vue"),
    },
    {
        path: "/newPay",
        name: "newPay",
        component: () => import("@/views/pay/newPay.vue"),
    },
    {
        path: "/h5paySuccess",
        name: "h5paySuccess",
        component: () => import("@/views/pay/h5PaySuccess.vue"),
    },
    // 安卓弹框的隐私协议
    {
        path: "/yinsi",
        name: "yinsi",
        component: () => import("@/views/yinsiAndxieyi/yinsi"),
    },
    {
        path: "/xieyi",
        name: "xieyi",
        component: () => import("@/views/yinsiAndxieyi/xieyi"),
    },
    {
        path: "/apkYinsi",
        name: "apkYinsi",
        component: () => import("@/views/apkText/yinsi")
    },
    {
        path: "/apkxieyi",
        name: "apkxieyi",
        component: () => import("@/views/apkText/xieyi")
    },
    {
        path: "/yinsi2",
        name: "yinsi2",
        component: () => import("@/views/apkText/yinsi2.vue")
    }
];

// 3. 创建路由实例并传递 `routes` 配置。
const router = createRouter({
    // 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHistory(),
    // 将通用路由和模块路由合并
    routes: routes,
});

export default router;
